import { Injectable } from "@angular/core";

import { BroadcastChannel } from 'broadcast-channel';

@Injectable({ providedIn: 'root' })
export class BaseService {
    public broadCastChannel: BroadcastChannel;

    constructor() {
        this.broadCastChannel = new BroadcastChannel('Partsfy');
    }
}
